// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedForeheadRestSensorDetectionAddOnError_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M18.75 24C21.6495 24 24 21.6495 24 18.75C24 15.8505 21.6495 13.5 18.75 13.5C15.8505 13.5 13.5 15.8505 13.5 18.75C13.5 21.6495 15.8505 24 18.75 24ZM16.875 15.75L15.75 16.875L17.625 18.75L15.75 20.625L16.875 21.75L18.75 19.875L20.625 21.75L21.75 20.625L19.875 18.75L21.75 16.875L20.625 15.75L18.75 17.625L16.875 15.75Z" fill="#ED5353"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M16.875 15.75L15.75 16.875L17.625 18.75L15.75 20.625L16.875 21.75L18.75 19.875L20.625 21.75L21.75 20.625L19.875 18.75L21.75 16.875L20.625 15.75L18.75 17.625L16.875 15.75Z" class="svg-fg"/>
  <path d="M15 5H1L4.22582e-09 7H13.5L10 10V20H11.6074C11.5368 19.5939 11.5 19.1763 11.5 18.75C11.5 17.8143 11.6772 16.9201 12 16.0989V11L15 8.5V5Z" class="svg-bg"/>
  <path d="M15.0178 12.5332C16.1412 11.331 17 9.5341 17 8C17 4.4 14.067 2 10.1851 2C8.41728 2 7.17583 2.60704 6.36455 3.48534C5.53459 4.38386 4.99996 5.73712 5 7.47364V8.66826L3.24595 11H5V16.5C5 17.1951 5.17632 17.5782 5.31097 17.7453C5.3976 17.8528 5.55726 18 6.02799 18H11.5383C11.513 18.2465 11.5 18.4968 11.5 18.75C11.5 19.1763 11.5368 19.5939 11.6074 20H6.02799C4 20 3 18.5 3 16.5V13H1.39234C0.042413 13 -0.248625 12.4737 0.188965 11.7368L3 8V7.47368C2.9999 3.18421 5.65945 0 10.1851 0C14.851 0 19 3 19 8C19 9.19525 18.6506 10.4213 18.1049 11.5283C16.983 11.6272 15.9344 11.9817 15.0178 12.5332Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedForeheadRestSensorDetectionAddOnError is a generated icon component.
 */
let IconMedForeheadRestSensorDetectionAddOnError = IconMedForeheadRestSensorDetectionAddOnError_1 = class IconMedForeheadRestSensorDetectionAddOnError extends IconBaseElement {
    render() {
        return html `${IconMedForeheadRestSensorDetectionAddOnError_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedForeheadRestSensorDetectionAddOnError.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedForeheadRestSensorDetectionAddOnError = IconMedForeheadRestSensorDetectionAddOnError_1 = __decorate([
    customElement('zui-icon-med-forehead-rest-sensor-detection-add-on-error')
], IconMedForeheadRestSensorDetectionAddOnError);
export { IconMedForeheadRestSensorDetectionAddOnError };
